import pulse from '@finn-no/pulse-sdk';
import { ProfileType } from '../../server/types.js';

// Tracking event: M_ev01
export const trackContactUs = (profileType?: ProfileType) =>
	pulse.trackEvent({
		type: 'Click',
		intent: 'Create',
		name: 'Send message',
		target: {
			id: 'id',
			type: 'Message',
		},
		object: {
			id: 'M_ev01',
			type: 'UIElement',
			elementType: 'Button',
			hasExtendedProfile: false,
			listingType: 'professional',
			profileType: profileType ? profileType : '',
		},
	});

// Tracking event: MO_ev60 object.name: Itempage
export const trackGoToItem = (
	orgName: string,
	itemUrl: string | undefined,
): void => {
	if (itemUrl) {
		pulse.trackEvent({
			type: 'Click',
			intent: 'Open',
			name: 'Homepage link clicked',
			object: {
				id: 'MO_ev60',
				name: 'Itempage',
				type: 'UIElement',
				elementType: 'Link',
				hasExtendedProfile: false,
				listingType: 'professional',
			},
			target: {
				id: itemUrl,
				type: 'ExternalContent',
				name: 'Go to webpage',
				provider: orgName,
			},
		});
	}
};

// Tracking event: MO_ev60 object.name: Homepage
export const trackHomepage = (
	orgName: string,
	homepageUrl: string | undefined,
) =>
	homepageUrl &&
	pulse.trackEvent({
		type: 'Click',
		intent: 'Open',
		name: 'Homepage link clicked',
		object: {
			id: 'MO_ev60',
			name: 'Homepage',
			type: 'UIElement',
			elementType: 'Link',
			hasExtendedProfile: false,
			listingType: 'professional',
		},
		target: {
			id: homepageUrl,
			type: 'ExternalContent',
			name: 'Go to webpage',
			provider: orgName,
		},
	});

// Tracking event: MO_ev61
export const trackMoreAdsFrom = (
	moreAdsFromUrl: string | undefined,
	orgName: string,
) =>
	moreAdsFromUrl &&
	pulse.trackEvent({
		type: 'Click',
		intent: 'View',
		name: 'More ads from this organization',
		object: {
			id: 'MO_ev61',
			type: 'UIElement',
			elementType: 'Link',
			hasExtendedProfile: false,
			listingType: 'professional',
		},
		target: {
			id: moreAdsFromUrl,
			name: 'Partner',
			type: 'Listing',
			provider: orgName,
		},
	});

// Tracking event: MO_ev59
export const trackPhone = (adId: string, orgName: string) =>
	pulse.trackEvent({
		type: 'Click',
		intent: 'Call',
		name: 'Contact seller',
		object: {
			id: 'MO_ev59',
			type: 'UIElement',
			elementType: 'Phone number',
			hasExtendedProfile: false,
			listingType: 'professional',
		},
		target: {
			id: adId,
			type: 'ExternalContent',
			name: 'Phone',
			provider: orgName,
			elementType: 'Phone number',
		},
	});

// Tracking event: MO_ev58
export const trackShowPhone = (orgName: string) =>
	pulse.trackEvent({
		type: 'Click',
		intent: 'Open',
		name: 'Contact seller',
		object: {
			id: 'MO_ev58',
			type: 'UIElement',
			elementType: 'Phone number',
			hasExtendedProfile: false,
			listingType: 'professional',
		},
		target: {
			id: 'show-phone-numbers',
			type: 'ExternalContent',
			name: 'Phone',
			provider: orgName,
			elementType: 'Phone number',
		},
	});
